module.exports = __webpack_public_path__ + "media/images/home/marketposter_ind_brasileiro-8bcb5f1fad6c01c0707f2b44539df180.png";